/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Directive, HostListener } from '@angular/core';
import { DownloadService } from '../services';

declare let html2canvas: any;

@Directive({
    selector: '[appScreenCapture]'
})
export class ScreenCaptureDirective {
    constructor(
        private downloadService: DownloadService
    ) {
    }

    /**
     * Add a host listener for checking the enter key.
     * @param event
     */
    @HostListener('document:keydown', ['$event'])
    public onKeydownHandler(event: KeyboardEvent): void {
        // Alt + Shift + L
        if (event.altKey && event.shiftKey && event.key === 'Ò') {
            this.createScreenshot();
        }
    }

    /**
     * Create screenshot.
     * @private
     */
    private createScreenshot(): void {
        // eslint-disable-next-line max-len
        const element = document.querySelector('.component-main, #content-wrapper form, #external-content-wrapper, .wizard-wrapper .wizard-step');
        const wrapper = document.createElement('div');
        const hasTable = document.querySelectorAll('app-table')?.length > 0;
        if (!hasTable) {
            wrapper.style.width = '436px';
        }

        element.parentNode.insertBefore(wrapper, element);
        wrapper.appendChild(element);
        html2canvas(wrapper).then(
            (canvas: any) => {
                wrapper.replaceWith(...Array.from(wrapper.childNodes));
                canvas.toBlob((blob: BlobPart) => {
                    const pathname = window.location.pathname;
                    const matches = pathname.match(/^(?:[^\/]*\/){3}(.*)$/);
                    const filename = matches && matches[1] ? matches[1] : pathname;
                    this.downloadService.generateDownload(blob, filename, { type: 'image/png' });
                });
            });
    }
}
